// PostHog header-navigation v2 and collection analytics.
(function () {
  'use strict';

  if (window.__phNavigationCollectionV2Loaded) return;
  window.__phNavigationCollectionV2Loaded = true;

  var VERSION = 'navigation-collection-v2';
  var NAV_VERSION = 'header-navigation-v2';
  var seenProducts = {};
  var seenNavItems = {};
  var IMMEDIATE_EVENTS = {
    nav_item_click: true,
    nav_utility_clicked: true,
    locale_selected: true,
    site_search_submitted: true,
    search_default_item_clicked: true,
    predictive_search_result_clicked: true,
    collection_product_clicked: true,
    collection_subcategory_clicked: true,
    collection_sort_changed: true,
    collection_filter_changed: true,
    collection_pagination_clicked: true,
    collection_content_clicked: true
  };

  function one(selector, root) { return (root || document).querySelector(selector); }
  function all(selector, root) { return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function text(el) { return el ? (el.textContent || '').replace(/\s+/g, ' ').trim() : ''; }
  function trackLabel(el) {
    if (!el) return '';
    var image = one('img[alt]', el);
    return (el.dataset.navItemName || el.getAttribute('aria-label') || (image && image.getAttribute('alt')) || text(el) || '').trim();
  }
  function number(value) {
    var parsed = Number(value);
    return isFinite(parsed) ? parsed : null;
  }
  function layout() { return window.matchMedia('(max-width: 989px)').matches ? 'mobile' : 'desktop'; }
  function pageType() {
    var match = (document.body && document.body.className || '').match(/template-([^\s]+)/);
    return match ? match[1] : 'unknown';
  }
  function common() {
    return {
      tracking_version: VERSION,
      page_type: pageType(),
      page_path: location.pathname,
      page_title: document.title,
      device_layout: layout(),
      page_locale: document.documentElement.lang || null
    };
  }
  function merge(target, source) {
    Object.keys(source || {}).forEach(function (key) { target[key] = source[key]; });
    return target;
  }
  function capture(event, properties) {
    if (!window.posthog || typeof window.posthog.capture !== 'function') return;
    var options = IMMEDIATE_EVENTS[event]
      ? { transport: 'sendBeacon', send_instantly: true }
      : undefined;
    window.posthog.capture(event, merge(common(), properties || {}), options);
  }
  function position(el, selector, root) {
    var explicit = number(el && el.dataset.trackPosition);
    if (explicit !== null && explicit > 0) return explicit;
    var list = all(selector, root || (el && el.parentElement) || document);
    var index = list.indexOf(el);
    return index < 0 ? null : index + 1;
  }
  function destinationType(href) {
    if (!href || href === '#') return null;
    var url;
    try { url = new URL(href, location.origin); } catch (e) { return null; }
    if (url.origin !== location.origin) return 'external';
    if (url.pathname.indexOf('/collections/') === 0) return 'collection';
    if (url.pathname.indexOf('/products/') === 0) return 'product';
    if (url.pathname.indexOf('/search') === 0) return 'search';
    if (url.pathname.indexOf('/account') === 0) return 'account';
    if (url.pathname.indexOf('/cart') === 0) return 'cart';
    return 'page';
  }
  function linkProps(a) {
    return {
      destination_url: a && a.href ? a.href : null,
      destination_type: a ? destinationType(a.getAttribute('href')) : null
    };
  }
  function safeQuery(value) {
    value = String(value || '').replace(/\s+/g, ' ').trim().slice(0, 100);
    if (/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) return '[redacted_email]';
    return value;
  }

  function initNavigation() {
    var header = one('#SiteHeader');
    if (!header) return;

    var megaTitles = {};
    all('[data-custom-mega]', header).forEach(function (mega) {
      megaTitles[(mega.dataset.navTitle || '').trim().toLowerCase()] = mega;
    });
    var lastOpen = {};
    var lastClose = {};

    function navSurface(el) {
      if (el && el.closest('.ch-drawer')) return 'mobile_drawer';
      if (el && el.closest('.custom-mega')) return 'desktop_mega';
      return layout() === 'mobile' ? 'mobile_header' : 'desktop_header';
    }

    function navLevel(el) {
      if (!el) return null;
      if (el.closest('.ch-drawer__sub')) return 2;
      if (el.closest('.ch-drawer__body')) return 1;
      if (el.closest('.custom-mega')) return 2;
      if (el.closest('.site-nav__deep-dropdown')) return 3;
      if (el.closest('.site-nav__dropdown')) return 2;
      return 1;
    }

    function navGroupRoot(el) {
      if (!el) return null;
      var namedGroup = el.closest('[data-nav-group-name]');
      if (namedGroup && namedGroup !== el) return namedGroup;
      return el.closest('.custom-mega__gift-group, .custom-mega__col, .custom-mega__inner, .ch-drawer__sub-links, .ch-drawer__sub-body, .ch-drawer__body, .site-nav__deep-dropdown, .site-nav__dropdown, .site-nav');
    }

    function navPosition(el) {
      var root = navGroupRoot(el) || (el && el.parentElement);
      if (!root) return null;
      var level = navLevel(el);
      if (level === 1 && !el.closest('.ch-drawer')) {
        root = one('.header-layout', header) || root;
      }
      var items = all('[data-nav-item-id]', root).filter(function (candidate) {
        if (navLevel(candidate) !== level) return false;
        if (level === 1 && !candidate.closest('.ch-drawer')) return true;
        return navGroupRoot(candidate) === root;
      });
      var index = items.indexOf(el);
      return index < 0 ? null : index + 1;
    }

    function navParent(el) {
      if (navLevel(el) === 1) return { id: null, name: null };
      var container = el && el.closest('[data-nav-parent-id]');
      if (container) {
        return {
          id: container.dataset.navParentId || null,
          name: container.dataset.navParentName || null
        };
      }
      var details = el && el.closest('.site-nav__details');
      var trigger = details && one(':scope > summary[data-nav-item-id]', details);
      return {
        id: trigger ? trigger.dataset.navItemId : null,
        name: trigger ? trackLabel(trigger) : null
      };
    }

    function navProps(el) {
      var parent = navParent(el);
      var group = el && el.closest('[data-nav-group-name]');
      return merge({
        nav_id: 'header_main_nav',
        nav_version: NAV_VERSION,
        item_id: el && el.dataset.navItemId || null,
        item_name: trackLabel(el) || null,
        position_index: navPosition(el),
        parent_item_id: parent.id,
        parent_item_name: parent.name,
        level: navLevel(el),
        navigation_surface: navSurface(el),
        group_name: group ? group.dataset.navGroupName || null : null,
        device_type: layout()
      }, linkProps(el));
    }

    function opened(el, surface, method, fallbackId, fallbackName) {
      var properties = el ? navProps(el) : {
        nav_id: 'header_main_nav',
        nav_version: NAV_VERSION,
        item_id: fallbackId,
        item_name: fallbackName,
        navigation_surface: surface,
        device_type: layout()
      };
      properties.navigation_surface = surface || properties.navigation_surface;
      properties.open_method = method;
      var key = properties.navigation_surface + ':' + properties.item_id;
      var now = Date.now();
      if (now - (lastOpen[key] || 0) < 800) return;
      lastOpen[key] = now;
      capture('nav_menu_opened', properties);
    }

    function closed(id, name, surface, method) {
      var key = surface + ':' + id + ':' + method;
      var now = Date.now();
      if (now - (lastClose[key] || 0) < 800) return;
      lastClose[key] = now;
      capture('nav_menu_closed', {
        nav_id: 'header_main_nav',
        nav_version: NAV_VERSION,
        item_id: id,
        item_name: name,
        navigation_surface: surface,
        close_method: method,
        device_type: layout()
      });
    }

    function initNavImpressions() {
      var items = all('[data-nav-item-id]').filter(function (item) {
        return !item.matches('a[href="#"]');
      });
      function record(item) {
        var props = navProps(item);
        var key = props.navigation_surface + ':' + props.item_id;
        if (!props.item_id || seenNavItems[key]) return;
        seenNavItems[key] = true;
        capture('nav_item_impression', props);
      }
      if (!('IntersectionObserver' in window)) {
        items.forEach(function (item) {
          if (item.getClientRects().length) record(item);
        });
        return;
      }
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting || entry.intersectionRatio < 0.5) return;
          record(entry.target);
          observer.unobserve(entry.target);
        });
      }, { threshold: 0.5 });
      items.forEach(function (item) { observer.observe(item); });
    }

    header.addEventListener('pointerover', function (event) {
      if (layout() !== 'desktop') return;
      var link = event.target.closest('.site-nav__item .site-nav__link');
      if (!link || (!megaTitles[trackLabel(link).toLowerCase()] && !link.closest('details'))) return;
      opened(link, 'desktop_header', 'hover');
    }, true);

    document.addEventListener('click', function (event) {
      var target = event.target;
      var surface = layout() === 'mobile' ? 'mobile_header' : 'desktop_header';
      var utility = target.closest('.ch-mobile-bar__logo, .header-item--logo a, .site-nav__link--icon, .ch-mobile-bar__btn, .ch-drawer__footer-account');
      if (utility) {
        var utilityName = null;
        if (utility.matches('.ch-mobile-bar__logo, .header-item--logo a')) utilityName = 'logo';
        else if (utility.matches('.js-search-header')) utilityName = 'search';
        else if (utility.matches('.js-drawer-open-cart, [aria-label="Cart"]')) utilityName = 'cart';
        else if (utility.matches('[aria-label="Account"], .ch-drawer__footer-account')) utilityName = 'account';
        else if (utility.matches('[data-ch-open-drawer], .js-drawer-open-nav')) utilityName = 'menu';
        if (utilityName === 'menu') opened(null, 'mobile_header', 'click', 'main_menu', 'Main menu');
        else if (utilityName) capture('nav_utility_clicked', merge({ utility_name: utilityName, navigation_surface: surface }, linkProps(utility)));
      }

      var subTrigger = target.closest('[data-ch-open-sub]');
      if (subTrigger) opened(subTrigger, 'mobile_drawer', 'click');

      var desktopTop = target.closest('.site-nav__item .site-nav__link');
      if (desktopTop && layout() === 'desktop' && desktopTop.matches('summary')) {
        opened(desktopTop, 'desktop_header', 'click');
      }

      var navItem = target.closest('[data-nav-item-id]');
      if (navItem && !navItem.matches('a[href="#"]')) {
        capture('nav_item_click', merge(navProps(navItem), {
          interaction_type: navItem.matches('a[href]') ? 'navigate' : 'open_submenu'
        }));
      }

      var close = target.closest('[data-ch-close-drawer], [data-ch-drawer-overlay], [data-ch-back]');
      if (close) {
        var activeSub = one('.ch-drawer__sub.is-open');
        var closeId = close.matches('[data-ch-back]') && activeSub ? activeSub.dataset.navParentId : 'main_menu';
        var closeName = close.matches('[data-ch-back]') && activeSub ? activeSub.dataset.navParentName : 'Main menu';
        closed(closeId, closeName, 'mobile_drawer', close.matches('[data-ch-back]') ? 'back' : (close.matches('[data-ch-drawer-overlay]') ? 'overlay' : 'close_button'));
      }

      if (layout() === 'desktop' && !target.closest('#SiteHeader')) {
        var openMega = one('.custom-mega.is-open', header);
        if (openMega) closed(openMega.dataset.navParentId, openMega.dataset.navParentName, 'desktop_mega', 'click_outside');
      }

      var locale = target.closest('[name="locale_code"], .ch-drawer__footer-locale');
      if (locale) capture('locale_selected', {
        from_locale: document.documentElement.lang || null,
        to_locale: locale.value || locale.getAttribute('value') || text(locale),
        navigation_surface: locale.closest('.ch-drawer') ? 'mobile_drawer' : surface
      });

      var defaultSearchLink = target.closest('[data-search-default-link]');
      if (defaultSearchLink) {
        capture('search_default_item_clicked', merge({
          item_type: defaultSearchLink.dataset.searchDefaultType || destinationType(defaultSearchLink.href),
          item_label: trackLabel(defaultSearchLink),
          item_position: number(defaultSearchLink.dataset.trackPosition),
          product_id: defaultSearchLink.getAttribute('data-product-id') || null,
          search_context: defaultSearchLink.closest('predictive-search') && defaultSearchLink.closest('predictive-search').dataset.context
        }, linkProps(defaultSearchLink)));
      }

      var predictiveLink = target.closest('[data-search-results] a[href]:not([data-search-default-link])');
      if (predictiveLink) {
        var resultRoot = predictiveLink.closest('[data-type-products], [data-type-collections], [data-type-pages], [data-type-articles]');
        var resultType = resultRoot ? Array.prototype.find.call(resultRoot.attributes, function (attr) { return attr.name.indexOf('data-type-') === 0; }) : null;
        var search = one('input[type="search"]', predictiveLink.closest('predictive-search'));
        capture('predictive_search_result_clicked', merge({
          search_query: safeQuery(search && search.value),
          result_type: resultType ? resultType.name.replace('data-type-', '') : destinationType(predictiveLink.href),
          result_position: position(predictiveLink, 'a[href]', resultRoot || predictiveLink.parentElement),
          product_id: predictiveLink.getAttribute('data-product-id') || null
        }, linkProps(predictiveLink)));
      }
    }, true);

    document.addEventListener('submit', function (event) {
      var form = event.target;
      if (!form.matches('predictive-search form, .site-header__search form')) return;
      var input = one('input[type="search"]', form);
      var searchRoot = form.closest('predictive-search') || form;
      var productResults = one('[data-search-live]:not([hidden]) [data-type-products], [data-search-default]:not([hidden]) [data-type-products]', searchRoot);
      capture('site_search_submitted', {
        search_query: safeQuery(input && input.value),
        result_count: number(productResults && productResults.dataset.typeProducts),
        source: searchRoot.dataset.context || 'header'
      });
    }, true);

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && (one('.ch-drawer.is-open') || one('.custom-mega.is-open'))) {
        var activeMega = one('.custom-mega.is-open', header);
        var activeSub = one('.ch-drawer__sub.is-open');
        closed(
          activeMega ? activeMega.dataset.navParentId : (activeSub ? activeSub.dataset.navParentId : 'main_menu'),
          activeMega ? activeMega.dataset.navParentName : (activeSub ? activeSub.dataset.navParentName : 'Main menu'),
          layout() === 'mobile' ? 'mobile_drawer' : 'desktop_mega',
          'escape'
        );
      }
    }, true);

    header.addEventListener('pointerout', function (event) {
      if (layout() !== 'desktop') return;
      var source = event.target.closest('.site-nav__item.has-custom-mega, .custom-mega.is-open');
      if (!source || (event.relatedTarget && source.contains(event.relatedTarget))) return;
      var activeMega = one('.custom-mega.is-open', header);
      if (!activeMega) return;
      var menuId = activeMega.dataset.navParentId;
      var menuName = activeMega.dataset.navParentName;
      setTimeout(function () {
        if (!one('.custom-mega.is-open', header)) closed(menuId, menuName, 'desktop_mega', 'hover_out');
      }, 260);
    }, true);

    initNavImpressions();
  }

  function initCollection() {
    var root = one('[data-ph-collection-grid]');
    if (!root) return;

    var params = new URLSearchParams(location.search);
    function activeFilters() {
      var filters = [];
      params.forEach(function (value, key) {
        if (key.indexOf('filter.') === 0) filters.push({ name: key, value: value });
      });
      try {
        var tags = JSON.parse(root.dataset.currentTags || '[]');
        tags.forEach(function (tag) { filters.push({ name: 'tag', value: tag }); });
      } catch (e) {}
      return filters;
    }
    function collectionProps() {
      return {
        collection_id: root.dataset.collectionId || null,
        collection_handle: root.dataset.collectionHandle || null,
        collection_title: root.dataset.collectionTitle || null,
        product_count: number(root.dataset.productCount),
        sort_by: params.get('sort_by') || null,
        active_filters: activeFilters()
      };
    }
    function cardProps(card) {
      return merge(collectionProps(), {
        item_list_id: 'collection_grid', list_id: 'collection_grid',
        list_position: number(card.dataset.listPosition),
        absolute_position: number(card.dataset.absolutePosition),
        page_number: number(card.dataset.pageNumber) || number(params.get('page')) || 1,
        product_id: card.dataset.productId || null,
        product_handle: card.dataset.productHandle || null,
        product_title: card.dataset.productTitle || null,
        price: number(card.dataset.price) === null ? null : number(card.dataset.price) / 100,
        compare_at_price: number(card.dataset.compareAtPrice) === null ? null : number(card.dataset.compareAtPrice) / 100,
        currency: root.dataset.currency || null
      });
    }

    capture('collection_viewed', collectionProps());

    var cards = all('[data-ph-product-card]', root);
    if ('IntersectionObserver' in window) {
      var pending = [];
      var flushTimer = null;
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          var card = entry.target;
          var key = card.dataset.productId || card.href;
          if (!entry.isIntersecting || seenProducts[key]) return;
          seenProducts[key] = true;
          pending.push(cardProps(card));
          observer.unobserve(card);
        });
        if (pending.length && !flushTimer) flushTimer = setTimeout(function () {
          var items = pending.splice(0, pending.length);
          flushTimer = null;
          capture('view_item_list', merge(collectionProps(), { item_list_id: 'collection_grid', items: items }));
        }, 120);
      }, { threshold: 0.5 });
      cards.forEach(function (card) { observer.observe(card); });
    } else if (cards.length) {
      capture('view_item_list', merge(collectionProps(), {
        item_list_id: 'collection_grid',
        items: cards.slice(0, 12).map(cardProps)
      }));
    }

    document.addEventListener('click', function (event) {
      var card = event.target.closest('[data-ph-product-card]');
      if (card) capture('collection_product_clicked', merge(cardProps(card), linkProps(card)));

      var tab = event.target.closest('.cg-tab[href]');
      if (tab) capture('collection_subcategory_clicked', merge(collectionProps(), merge({
        subcategory_label: text(tab),
        subcategory_handle: (tab.getAttribute('href') || '').split('/collections/')[1] || null,
        element_position: position(tab, '.cg-tab', tab.parentElement)
      }, linkProps(tab))));

      var pagination = event.target.closest('.cg-pagination a[href]');
      if (pagination) {
        var fromPage = number(params.get('page')) || 1;
        var nextUrl = new URL(pagination.href, location.origin);
        var toPage = number(nextUrl.searchParams.get('page')) || 1;
        capture('collection_pagination_clicked', merge(collectionProps(), {
          from_page: fromPage, to_page: toPage,
          direction: /previous/i.test(text(pagination)) ? 'previous' : (/next/i.test(text(pagination)) ? 'next' : 'page_number')
        }));
      }

      var clear = event.target.closest('.cg-clear-filters[href]');
      if (clear) capture('collection_filter_changed', merge(collectionProps(), {
        action: 'clear', filter_name: 'all', filter_value: null,
        is_selected: false, result_count_before: number(root.dataset.productCount)
      }));

      var panelAction = event.target.closest('[data-cg-open-filters], [data-cg-close-filters], .cg-filters-drawer button[type="submit"]');
      if (panelAction) capture('collection_filter_panel_interaction', merge(collectionProps(), {
        action: panelAction.matches('[data-cg-open-filters]') ? 'open' : (panelAction.matches('[type="submit"]') ? 'apply' : 'close'),
        close_method: panelAction.matches('.cg-filters-drawer-overlay') ? 'overlay' : (panelAction.matches('[data-cg-close-filters]') ? 'close_button' : null)
      }));

      var contentLink = event.target.closest('.template-collection .richtextfornewdesign a[href], .template-collection [id^="FeatureRowsStatic-"] a[href], .template-collection [id^="BrandStory-"] a[href], .template-collection [id^="FaqStatic-"] a[href], .template-collection .breadcrumb a[href], .template-collection .gift-sale-banner a[href]');
      if (contentLink) {
        var component = contentLink.closest('[id]');
        capture('collection_content_clicked', merge(collectionProps(), merge({
          component_name: component ? component.id.replace(/-.*/, '').toLowerCase() : 'collection_content',
          component_id: component ? component.id : null,
          content_name: text(contentLink),
          element_position: position(contentLink, 'a[href]', component || contentLink.parentElement)
        }, linkProps(contentLink))));
      }

      var dot = event.target.closest('[data-fc-dot]');
      if (dot) {
        var activeDot = one('[data-fc-dot].is-active', dot.parentElement);
        capture('collection_carousel_navigated', merge(collectionProps(), {
          component_id: (dot.closest('[id]') || {}).id || null,
          from_position: activeDot ? number(activeDot.dataset.fcDot) + 1 : null,
          to_position: number(dot.dataset.fcDot) + 1
        }));
      }
    }, true);

    document.addEventListener('change', function (event) {
      var select = event.target.closest('.cg-sort-select');
      if (select && root.contains(select)) capture('collection_sort_changed', merge(collectionProps(), {
        sort_from: params.get('sort_by') || null,
        sort_to: select.value,
        product_count: number(root.dataset.productCount)
      }));

      var checkbox = event.target.closest('.cg-filter-option input[type="checkbox"]');
      if (checkbox && root.contains(checkbox)) {
        var details = checkbox.closest('.cg-filter');
        capture('collection_filter_changed', merge(collectionProps(), {
          action: checkbox.closest('[data-cg-filters-drawer]') ? 'select_pending' : 'select_apply',
          filter_name: text(one('.cg-filter-summary span', details)) || checkbox.name,
          filter_value: checkbox.value,
          is_selected: checkbox.checked,
          result_count_before: number(root.dataset.productCount)
        }));
      }

      var range = event.target.closest('[data-cg-range-min], [data-cg-range-max]');
      if (range && root.contains(range)) {
        var slider = range.closest('[data-cg-price-slider]');
        capture('collection_filter_changed', merge(collectionProps(), {
          action: range.closest('[data-cg-filters-drawer]') ? 'price_pending' : 'price_apply',
          filter_name: 'price', filter_value: null, is_selected: true,
          price_min: number(one('[data-cg-range-min]', slider).value),
          price_max: number(one('[data-cg-range-max]', slider).value),
          result_count_before: number(root.dataset.productCount)
        }));
      }
    }, true);

    all('.cg-filter', root).forEach(function (details) {
      details.addEventListener('toggle', function () {
        capture('collection_filter_panel_interaction', merge(collectionProps(), {
          action: details.open ? 'filter_group_open' : 'filter_group_close',
          filter_name: text(one('.cg-filter-summary span', details))
        }));
      });
    });
    all('[id^="FaqStatic-"] details').forEach(function (details, index) {
      details.addEventListener('toggle', function () {
        capture('collection_faq_toggled', merge(collectionProps(), {
          question: text(one('summary', details)), question_position: index + 1,
          action: details.open ? 'open' : 'close'
        }));
      });
    });
  }

  function init() {
    initNavigation();
    initCollection();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
